import { createSlice } from "@reduxjs/toolkit";
import { resetALL } from "../../../../../../../.globals/redux/actions";

const INIT_STATE = {
    open: false,
    workOrderId: null,
    preloadedData: null
};

const workOrdersCreateEditWorkOrderRedux = createSlice({
    name: "workOrders/createEditWorkOrder",
    initialState: INIT_STATE,
    reducers: {
        resetWorkOrder(state, action) {
            return action.payload
                ? { ...state, ...action.payload }
                : { ...INIT_STATE };
        },
        openModalCreateEditWorkOrder(state, action) {
            state.open = true;
            state.workOrderId = action?.payload?.workOrderId;
            state.preloadedData = action?.payload?.preloadedData || null;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(resetALL, () => INIT_STATE);
    },
});

// Extract and export the action creators object and the reducer
export const { actions, reducer } = workOrdersCreateEditWorkOrderRedux;

// Extract and export each action creator by name
export const {
    resetWorkOrder,
    openModalCreateEditWorkOrder,
} = actions;

// Export the reducer, either as a default or named export
export default reducer;
